import * as Pages from '../../pages';

import { VIEW_TYPES } from '../../constants/viewTypes';
import { ROUTE_ACCESS_TYPE } from '../../constants/routeAccessType';

export const cyclesRoute = [
    {
        path: '/cycles',
        route_access_type: ROUTE_ACCESS_TYPE.private,
        component: Pages.CraftCyclesIndexPage,
        permissionRules: {
            availableViewTypes: [VIEW_TYPES.client],
        },
    },
    {
        path: '/cycle/:cycleId',
        indexPath: '/cycles',
        route_access_type: ROUTE_ACCESS_TYPE.private,
        component: Pages.CraftCycleDetailPage,
        permissionRules: {
            availableViewTypes: [VIEW_TYPES.client],
        },
    },
];
